import { useI18n } from 'domains/i18n/hooks'
import { useAppDispatch } from 'domains/store'
import type { RootState } from 'domains/store'
import {
  disableEventsTranslation,
  enableEventsTranslation,
} from 'domains/translations/slice'
import { className } from 'lib/css'
import { useCallback } from 'preact/hooks'
import { useSelector } from 'react-redux'
import EventDivider from 'ui/components/conversation/event-divider'
import { useEvents } from 'ui/hooks/seamly-state-hooks'

const NewTranslationDivider = ({ event }) => {
  const { t } = useI18n()
  const events = useEvents()
  const {
    body: { translationEnabled, text, title },
    id,
  } = event.payload
  const translatedEventGroups = useSelector(
    (state: RootState) => state.translations.translatedEventGroups,
  )

  const dispatch = useAppDispatch()
  const toggleTranslations = useCallback(() => {
    if (!translatedEventGroups[id]) {
      dispatch(disableEventsTranslation({ events, id }))
      return
    }

    dispatch(enableEventsTranslation({ events, id }))
  }, [dispatch, events, id, translatedEventGroups])

  return (
    <EventDivider
      iconName="newTranslation"
      dividerType="new-translation"
      title={title}
      description={text}
    >
      {translationEnabled ? (
        <>
          <button
            className={className('button', 'button--secondary')}
            onClick={toggleTranslations}
          >
            {t(
              !translatedEventGroups[id]
                ? 'translations.toggle.hideTranslationsButtonText'
                : 'translations.toggle.showTranslationsButtonText',
            )}
          </button>
        </>
      ) : null}
    </EventDivider>
  )
}

export default NewTranslationDivider
